import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function csrSet(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{
    csrOid: string | null;
    csrName: string | null;
    csrEmail: string | null;
  }>,
) {
  const { csrOid, csrName, csrEmail } = action.payload;

  state.csrOid = csrOid;
  state.csrName = csrName;
  state.csrEmail = csrEmail;
}
